export default function Overlay({ src, style }) {
    return (
        <img
            src={src}
            className="overlay"
            alt=""
            style={{
                position: 'absolute',
                zIndex: 10,
                pointerEvents: 'none',
                ...style,
            }}
        />
    );
}
